import { Injectable } from '@angular/core';
import { Store } from './store';
import { DealState } from './deal.state';

@Injectable()
export class DealStore extends  Store<DealState> {
  constructor () {
    super(DealState);
  }
}